module.exports = "/fonts/fa-regular-400.svg?da8a235bb207c74eea21507f3a86a53b";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-regular-400.svg
// module id = +x5x
// module chunks = 0 1